import { render, staticRenderFns } from "./NewNotification.vue?vue&type=template&id=0949eeee&scoped=true"
import script from "./NewNotification.vue?vue&type=script&lang=js"
export * from "./NewNotification.vue?vue&type=script&lang=js"
import style0 from "./NewNotification.vue?vue&type=style&index=0&id=0949eeee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0949eeee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
